import React, { Component } from 'react';
import axios from '../../../axios-ns';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import CardContent from '@material-ui/core/CardContent';
import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import MuiAudioPlayer from '../../AudioPlayer';
import Aux from '../../../hoc/Aux';
import * as messages from '../../../messages';
import classes from '../../../index.css';
import Spinner from '../../../components/UI/Spinner/Spinner';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Snackbar from '@material-ui/core/Snackbar';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import * as classesAR from '../../../containers/AudioRecorder/AudioRecorder.css';

import RightIcon from '@material-ui/icons/ArrowForward';
import DoneIcon from '@material-ui/icons/Done';
import LeftIcon from '@material-ui/icons/ArrowBack';
import TopIcon from '@material-ui/icons/ArrowUpward';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import AudioRecorder from '../../AudioRecorder/AudioRecorder';
import Message from '../Message/Message';
import ChatIcon from '@material-ui/icons/Chat';
import AudioTrackIcon from '@material-ui/icons/Audiotrack';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

import Recorder from 'recorder-js';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import Metronome from '../Metronome/Metronome';

const styles = theme => ({
    title: {
        color: 'red',
    }
});

class TrainingChapter extends Component {
    state = {
        chapter: null,
        loading: true,
        trainingCode: null,
        allDone: false,
        correct: 0,
        recorder: null,
        recordingMaterialCode: null,
        recordingStatus: null,
        open: false,
        sending: false
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.chapterCode !== this.props.match.params.chapterCode) {
            this.setState({ ...this.state, loading: true });
            this.getData();
            window.scrollTo(0, 0);
        }
    }

    getData() {
        if (localStorage.getItem('token')) {
            axios.get('protected/products/chapter/' + this.props.match.params.chapterCode + "/" + this.props.match.params.trainingCode, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then(response => {
                    this.setState({ chapter: response.data, trainingCode: this.props.match.params.trainingCode, loading: false });
                }).catch(err => {
                    this.setState({ loading: false });
                    console.log("error");
                })
        }
    }

    componentDidMount() {
        this.getData();

        this.setState({
            ...this.state, recorder: new Recorder(new (window.AudioContext || window.webkitAudioContext)(), {
            })
        });

        navigator.mediaDevices.getUserMedia({ audio: true })
            .then(stream => {
                console.log("Initializing recorder");
                this.state.recorder.init(stream);

            })
            .catch(err => console.log('Uh oh... unable to get stream...', err));

    }

    replace(content) {
        return content.replace('<iframe', '<div style="position: relative; padding-bottom: 56.25%; padding-top: 25px; height: 0;"><iframe style="position: absolute; top: 0; left: 0;	width: 100%; height: 100%; "').replace('</iframe>', '>/iframe></div>')
    }

    onSnackbarClose = (event, reason) => {
        this.setState({ ...this.state, showSnackbar: false });
    }

    audioPlayerClickHandler = (action) => {
        if (action.playStatus && action.playStatus === 'play') {
            axios.post('/protected/audio/played', null, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then(response => {

                })
        } else {
            axios.post('/protected/audio/stopped', null, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then(response => {

                })
        }
    }

    sendQueryAnswer = (materialCode, answer) => {
        axios.post('protected/audio/compare', { materialCode: materialCode, answer: answer }, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                let allDone = true;
                let materials = this.state.chapter.materials.map(m => {
                    let done = m.materialCode === materialCode;
                    if (!done) allDone = false;
                    return { ...m, done: done, correct: response.data };
                });

                this.setState({ ...this.state, showSnackbar: true, chapter: { ...this.state.chapter, materials: materials }, message: 'Twoja odpowiedź została zapisana', allDone: allDone, correct: (this.state.correct + response.data) });
            })
            .catch(err => { });
    }

    messageSent = (materialCode) => {
        this.setState({ ...this.state, showSnackbar: true, snackbarVariant: 'warning', message: 'Twoja wiadomość została wysłana' });

        axios.get('/protected/products/material/' + materialCode + '/messages', { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                let materials = this.state.chapter.materials.map(m => {
                    if (m.materialCode === materialCode) {
                        m.messages = response.data;
                    }
                    return m;
                })
                this.setState({ ...this.state, chapter: { ...this.state.chapter, materials: materials } });
            })
            .catch(err => {
                console.log("Error");
            })
    }

    handleClickOpen = (material) => {
        this.setState({ ...this.state, open: true, recordingMaterialCode: material.materialCode, backgroundSound: material.backgroundSound, backgroundSoundLength: material.backgroundSoundLength });
    };

    handleClose = () => {
        this.setState({ ...this.state, open: false });
    };

    handleError = (message) => {
        this.setState({
            ...this.state, message: message, showSnackbar: true, snackbarVariant: 'error', recorder: new Recorder(new (window.AudioContext || window.webkitAudioContext)(), {
            })
        }, () => {
            setTimeout(() => { document.location.reload(); }, 3000);
        });
    }

    onAudioRecord = (materialCode) => {
        this.state.recorder.start()
            .then(() => {
                this.setState({ ...this.state, recordingMaterialCode: materialCode, recordingStatus: 'RECORDING' })
            });

    }

    onAudioStop = (materialCode) => {
        this.setState({ ...this.state, recordingStatus: 'STOP' });
        this.state.recorder.stop()
            .then(({ blob, buffer }) => {
                try {
                    this.setState({ ...this.state, blob: blob });
                } catch (er) {
                }
            });
    }

    onAudioSend = (materialCode, blob) => {
        const data = new FormData();
        data.append('sample', blob, 'testfile.wav');
        data.append('materialCode', materialCode);
        data.append('transactionCode', this.props.match.params.trainingCode);

        this.setState({ ...this.state, open: false, sending: true });
        
        axios.post('protected/audio/analysis', data, { headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                let materials = this.state.chapter.materials.map(m => {
                    if (m.materialCode === materialCode) {
                        m.evaluations.push({ status: 'NOT_EVALUATED' });
                    }
                    return m;
                });                    
                this.setState({ ...this.state, sending: false, showSnackbar: true, message: 'Twoje nagranie zostało wysłane do analizy', recordingStatus: null, recordingMaterialCode: null, chapter: { ...this.state.chapter, materials: materials } });
            })
            .catch(err => { });
    }

    setChapterInstanceStatus(status) {
        let data = {status: status, chapterCode: this.props.match.params.chapterCode, transactionCode: this.props.match.params.trainingCode};
        axios.put('protected/products/product-chapter-instance', data, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
        .then(response => { this.setState({...this.state, chapter: {...this.state.chapter, status: status}})})
    }

    finishService = () => {
        axios.put('/protected/transaction/' + this.props.match.params.trainingCode +'/' + 'WAITING_FOR_EVALUATION', null, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
        .then(response => { this.setState({...this.state, finished: true})});
    }

    render() {
        let chapter = null;
        let materials = null;

        if (this.state.chapter) {
            chapter = this.state.chapter.showContent !== 'FALSE' ? <div style={{ textAlign: 'justify', padding: '10px' }} dangerouslySetInnerHTML={{ __html: this.state.chapter ? this.replace(this.state.chapter.content) : null }}></div> : null;
            if (this.state.chapter.materials) {
                materials = this.state.chapter.materials.map(m => {

                    let toolComponents = null;

                    if(m.tools != null) {
                        let tools = JSON.parse(m.tools);             

                        toolComponents = tools.map(t => t.tool === 'METRONOME' ? <Metronome key={Math.random()} time={t.time} tempo={t.tempo}/> : null); 
                    }

                    let mediaItems = null;

                    if (m.mediaItems) {
                        mediaItems = m.mediaItems.map(mi => {
                            return <Card key={Math.random()}>
                                <MuiAudioPlayer
                                    onClick={(action) => this.audioPlayerClickHandler(action)}
                                    src={mi.path}
                                    autoPlay={false}
                                />
                            </Card>
                        });
                    }

                    let sendSample = null;
                    let evaluations = null;
                    let query = null;
                    let question = null;

                    if (m.type === 'Q_COMPARE') {
                        if (m.done) {
                            query = <p>Ćwiczenie wykonane</p>;
                        } else {
                            query = (<Card>
                                <Button variant="outlined" color="primary" type="button" onClick={() => this.sendQueryAnswer(m.materialCode, 1)}>
                                    {messages.SAME}
                                </Button>
                                <Button variant="outlined" color="primary" type="button" onClick={() => this.sendQueryAnswer(m.materialCode, 0)}>
                                    {messages.DIFFERENT}
                                </Button>
                            </Card>);
                        }
                    }

                    //if(this.state.chapter.allowSendQuestions == 'TRUE') {
                    let smessages = null;
                    let head = (
                        <CardHeader
                            avatar={
                                <Avatar aria-label="Recipe" className={classes.avatar} style={{ backgroundColor: 'orange' }}>
                                    <ChatIcon />
                                </Avatar>
                            }
                            title="Zadaj pytanie"
                        />);

                    if (m.messages != null && m.messages.length > 0) {
                        smessages = m.messages.map(me => {
                            let question = <Card style={{ padding: '5px', margin: '5px' }}><b style={{ color: 'orange' }}>Ty: </b> {me.question}</Card>
                            let answer = me.answer ? <Card style={{ padding: '5px', margin: '5px' }}><b>Karina: </b> {me.answer}</Card> : null;
                            return (
                                <Aux key={me.studentQuestionCode}>
                                    {question}
                                    {answer}
                                </Aux>
                            );
                        })
                    }

                    if (this.state.chapter.allowSendQuestions === 'TRUE') {
                        question = (<Card style={{ paddingTop: '10px', paddingBottom: '10px', marginTop: '5px' }} key={m.studentSampleCode}>
                            {head}
                            {smessages}
                            <Message materialCode={m.materialCode} transactionCode={this.props.match.params.trainingCode} onMessageSent={() => this.messageSent(m.materialCode)} />
                        </Card>);
                    }

                    if (this.state.chapter.allowSendSamples === 'TRUE' && m.canSendSample) {
                        if (m.evaluations) {
                            evaluations = m.evaluations.map(e => {
                                if (e.status != 'EVALUATED' && this.state.sending == false) {
                                    return <Card style={{ padding: '10px' }} key={Math.random()}>
                                        <p style={{ color: '#ccc' }}>
                                            {this.state.chapter.productCode == 'SPS' ? 'Ćwiczenie wykonane, przejdź dalej' : 'Oczekiwanie na ocenę'}
                                        </p>
                                    </Card>
                                }

                                let fill = +e.score;
                                let border = 5 - +e.score;
                                let stars = Array(fill).fill(1).map(e => <StarIcon style={{ color: 'orange' }} key={Math.random()} />);
                                let borderStars = Array(border).fill(1).map(e => <StarBorderIcon style={{ color: 'orange' }} key={Math.random()} />);

                                return (
                                    <Card style={{ padding: '10px', marginBottom: '5px' }} key={e.studentSampleCode}>
                                        <p><b>Karina <span style={{ fontSize: '10px' }}>({e.answerDate})</span></b></p>
                                        {stars}
                                        {borderStars}
                                        <p style={{ fontSize: '12px' }}>{e.comment}</p>
                                    </Card>
                                )
                            });
                        }

                        let notEvaluatedSampleExist = m.evaluations.filter(e => e.status != 'EVALUATED');

                        let audioRecorder = notEvaluatedSampleExist.length > 0 ? null :
                            <Aux>
                                <Button color="primary" style={{ marginLeft: '10px' }} onClick={() => this.handleClickOpen(m)}>
                                    Nagraj ćwiczenie</Button>
                            </Aux>;

                        if(this.state.sending) {
                            audioRecorder = null;
                            evaluations = <p className={classesAR.Blink} style={{ color: '#ccc', padding: '10px' }}><AccessTimeIcon/>&nbsp;Przesyłanie nagrania. Proszę czekać...</p>;
                        }

                        if(this.state.chapter.productCode == 'SPS') {
                            sendSample = (
                                <Card style={{ marginBottom: '5px', marginTop: '5px' }}><br/>
                                    {audioRecorder}
                                    <CardContent style={{ padding: '5px' }}>
                                        {evaluations}
                                    </CardContent>
                                </Card>
                            );
                        } else {
                            sendSample = (
                                <Card style={{ marginBottom: '5px', marginTop: '5px' }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar aria-label="Recipe" className={classes.avatar} style={{ backgroundColor: 'orange' }}>
                                                <AudioTrackIcon />
                                            </Avatar>
                                        }
                                        title={'Sprawdź się!'}
                                    />
                                    {audioRecorder}
                                    <CardContent style={{ padding: '5px' }}>
                                        {evaluations}
                                    </CardContent>
                                </Card>
                            );    
                        }

                    }

                    return <Card style={{ marginBottom: '12px' }} key={Math.random()}>
                        <CardHeader title={m.title} />

                        <CardContent>
                            <p style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: m.content }} />
                            {mediaItems}
                            {toolComponents}
                            {sendSample}
                            {query}
                            {question}
                        </CardContent>
                    </Card>
                }
                );
            }
        }

        let view = null;
        let bottomNav = null;

        if (this.state.loading) {
            view = <Spinner />;
        } else {
            if (this.state.chapter && !this.state.sending) {

                let prevChapter = this.state.chapter.prevChapterCode ? <BottomNavigationAction label="Prev chapter" value="recents" icon={<LeftIcon />} component={Link} to={'/protected/training/' + this.state.trainingCode + '/chapter/' + this.state.chapter.prevChapterCode} /> : null;
                let nextChapter = this.state.chapter.nextChapterCode ? <BottomNavigationAction label="Next chapter" value="recents" icon={<RightIcon />} component={Link} to={'/protected/training/' + this.state.trainingCode + '/chapter/' + this.state.chapter.nextChapterCode} /> : null;
                let goUp = <BottomNavigationAction label="Product" value="recents" icon={<TopIcon />} component={Link} to={'/protected/training/' + this.state.trainingCode} />;
                bottomNav = (
                    <Aux>
                        {prevChapter}
                        {goUp}
                        {nextChapter}
                    </Aux>);

            }

            let name = this.state.chapter ? this.state.chapter.name : null;

            let title = <div style={{width: '500px', height: '40px'}}><div style={{float: 'left'}}>{name}</div><div style={{float: 'right'}}>{this.state.chapter.status == 'DONE' ? <DoneIcon style={{fontSize: '30px', color: 'green', marginRight: '20px'}}/> : null}</div></div>

            let completeButton = null;

            if(this.state.chapter.status == 'CREATED') {
                completeButton = <p style={{textAlign: 'center'}}><Button color="primary" variant="contained" onClick={() => this.setChapterInstanceStatus('DONE')}>Oznacz jako zakończony</Button></p>
            } else if(this.state.chapter.status == 'DONE') {
                completeButton = <p style={{textAlign: 'center'}}><Button color="secondary" variant="contained" onClick={() => this.setChapterInstanceStatus('CREATED')}>Oznacz jako do wykonania</Button></p>
            }

            let header = this.state.chapter.description ? <CardHeader title={title} subheader={this.state.chapter ? this.state.chapter.description : null} /> : null;

            view = <Aux>
                <Card style={{ padding: '5px', marginBottom: '65px', width: '100%' }}>
                    {header}
                    {chapter}
                    <Grid justify="center" alignItems="center" container>
                        <Grid item key={Math.random()}>
                            {materials}
                        </Grid>
                    </Grid>
                    <p style={{ display: this.state.chapter && this.state.chapter.summary ? 'block' : 'none' }} className={classes.Summary} dangerouslySetInnerHTML={{ __html: this.state.chapter ? this.state.chapter.summary : null }} />
                    {completeButton}
                </Card>
            </Aux>

            if (this.state.allDone) {
                let score = this.state.correct * 100 / this.state.chapter.materials.length;
                view = (<Card style={{ padding: '10px' }}>
                    <h2>Test zakończony! Twój wynik to: {this.state.correct} / {this.state.chapter.materials.length}</h2>
                    <p>{score > 90 ? <b>Super Ci poszło</b> : null} </p>
                    <p>{score > 80 && score <= 90 ? <b>Było bardzo dobrze!</b> : null} </p>
                    <p>{score > 70 && score <= 80 ? <b>Było całkiem nieźle!</b> : null} </p>
                    <p>{score > 60 && score <= 70 ? <b>Poszło Ci przeciętnie</b> : null} </p>
                    <p>{score > 50 && score <= 60 ? <b>Nie najlepiej Ci poszło</b> : null} </p>
                    <p>{score > 10 && score <= 50 ? <b>Twój wynik jest gorszy od przeciętnej</b> : null} </p>
                </Card>);
            }

            if(this.state.chapter.finish == '1') {
                view = <Card style={{ padding: '10px' }}>
                    Uff! Ciężko było, prawda? Ale teraz Twoja praca jest już skończona, a moja dopiero się zaczyna:) Przystępuję do analizy materiału, który udało mi się zebrać. Jak tylko raport będzie gotowy, odezwę się do Ciebie!
                    <p style={{textAlign: 'center'}}>
                        Kliknij poniższy przycisk aby zakończyć.<br/><br/>
                        <Button color="primary" variant="contained" type="submit" variant="contained" type="submit" style={{ marginBottom: '35px', backgroundColor: 'orange', marginBottom: '35px' }} onClick={() => this.finishService()}>
                            Zakończ weryfikację
                        </Button>
                    </p>
                </Card>
            }
            
            if (this.state.finished) {
                view = <Card style={{ padding: '10px' }}>
                    Przekazaliśmy Twoje nagrania do weryfikacji. Po zakończeniu tego procesu otrzymasz wiadomość na swoją skrzynkę email. Prosimy o odrobinę cierpliwości.
                    </Card>
            }
        }

        return (
            <Aux>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title" onClose={this.handleClose}>Nagraj ćwiczenie
                    <IconButton color="primary" style={{float: 'right', marginTop: '-20px', marginRight: '-20px'}} component="span" onClick={this.handleClose}>
                            <CancelIcon style={{color: '#ddd', fontSize: '40px'}} />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Wykonaj ćwiczenie i prześlij je do oceny!
            </DialogContentText>
                        <AudioRecorder backgroundSound={this.state.backgroundSound} maxTime={this.state.backgroundSoundLength ? this.state.backgroundSoundLength : 30} materialCode={this.state.recordingMaterialCode} onSend={this.onAudioSend} handleError={this.handleError} recorder={this.state.recorder} />
                    </DialogContent>
                    {/* <DialogActions>
                    </DialogActions> */}
                </Dialog>

                <Snackbar open={this.state.showSnackbar} anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                    autoHideDuration={3000}
                    onClose={this.onSnackbarClose}
                    variant={this.state.snackbarVariant}
                    bodyStyle={{ backgroundColor: 'red' }}
                    message={<span dangerouslySetInnerHTML={{ __html: this.state.message }}></span>} />

                {view}
                <BottomNavigation style={{ width: '100%', bottom: '0', right: '0', backgroundColor: 'orange', position: 'fixed' }}>
                    <Aux>
                        {bottomNav}
                    </Aux>
                </BottomNavigation>
            </Aux>
        );
    };
}

export default TrainingChapter; 